import React, { useCallback } from 'react';
import { Input } from 'reactstrap';
import { useController } from 'react-hook-form';
import { TypedMemo } from '../../../common/types';
import { FormInputContainer } from '../../../forms/components/FormInputContainer/FormInputContainer';
import { PresaveDateFieldProps } from './props';

/**
 * A day, not a moment. The browser's own date control is used rather than a
 * text field so the artist cannot type a date that does not exist, and `min`
 * keeps them out of the past — a campaign for a day gone by has nobody to
 * notify.
 */
const PresaveDateFieldComponent: React.FC<PresaveDateFieldProps> = ({ control, name, label, help, disabled, min }) => {
  const { field, fieldState } = useController({ control, name });
  const { value, onChange } = field;
  const { error, invalid, isDirty, isTouched } = fieldState;

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <FormInputContainer
      label={label}
      help={help}
      name={name}
      error={error?.message}
      isDirty={isDirty}
      isTouched={isTouched}
    >
      <Input
        id={name}
        name={name}
        type="date"
        min={min}
        value={value ?? ''}
        invalid={invalid}
        disabled={disabled}
        onChange={handleChange}
      />
    </FormInputContainer>
  );
};

export const PresaveDateField = TypedMemo(PresaveDateFieldComponent);
